import { useState } from 'react';
import { useGetApartmentMutation } from '@services/member/apartment/apartment.endpoints';
import { Apartment } from '@services/member/apartment/apartment.types';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

export const useDetailsPreviewVM = () => {
    const { id } = useParams();
    const [apartment, setApartment] = useState<Apartment>();

    const [
        getApartment,
        {
            isLoading: isGetApartmentLoading,
            isUninitialized: isGetApartmentUninitialized,
            isError: isGetApartmentError,
            isSuccess: isGetApartmentSuccess,
            error: getApartmentError,
            data: getApartmentResponse
        }
    ] = useGetApartmentMutation();
    

    useEffect(() => {
        if (!id) return;
        getApartment({ id });
    }, [id]);

    useEffect(() => {
        if (isGetApartmentLoading) return;
        if (isGetApartmentError) return;
        if (getApartmentError) return;

        if (isGetApartmentSuccess && getApartmentResponse) {
            setApartment(getApartmentResponse.data);
        }
    }, [isGetApartmentError, isGetApartmentSuccess, getApartmentError, getApartmentResponse, isGetApartmentLoading]);

    return {
        isLoading: isGetApartmentUninitialized || isGetApartmentLoading,
        isError: isGetApartmentError && !apartment,
        apartment,
    };
};
